'use strict';
namespace TR {

    import TripService = Core.TripService;

    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
        productId: string;
    }

    class PriorityBoarding {
        isSelected: boolean = false;
        basketId: string | undefined;
        details: any;
        totalPrice: number;

        constructor(private $routeParams: RouteParams,
                    private basketService: any,
                    private basketStore: any,
                    private tripService: TripService) {

            tripService.getTrip($routeParams.tripId).then((trip: Core.Trip.TripState) => {
                this.basketId = trip.BasketId;
            });

            this.totalPrice = this.details.optionDetails.UnitAmount * this.details.optionDetails.Quantity;
        }

        public updatePriorityBoarding(pbSelectedStatus): void {
            this.basketStore.updatePriorityBoarding(this.basketId, this.details.optionDetails, pbSelectedStatus)
                .then(() => {
                    this.basketService.updateBasket();
                    this.details.isSelected = pbSelectedStatus;
                });
        }
    }

    angular
        .module('TR')
        .component('priorityBoarding', {
            bindings: {
                details: '<'
            },
            controller: PriorityBoarding,
            controllerAs: 'pb',
            templateUrl: 'partials/home/directivetemplate?type=PriorityBoarding'
        });
}
